import { FEATURE_FLAGS } from "@chef/constants";

import { useFlag } from "@chef/feature-flags";

import { WeekEditorConfirmOrderExperimental } from "./WeekEditorConfirmOrderExperimental/WeekEditorConfirmOrderExperimental";
import { WeekEditorConfirmOrderDefault } from "./WeekEditorConfirmOrderDefault";

interface WeekEditorConfirmOrderProps {
  week: number;
  year: number;
}

export const WeekEditorConfirmOrder = ({
  week,
  year,
}: WeekEditorConfirmOrderProps) => {
  const { enabled: isWeekEditorRedesignEnabled } = useFlag(
    FEATURE_FLAGS.WEEK_EDITOR_REDESIGN,
  );

  return isWeekEditorRedesignEnabled ? (
    <WeekEditorConfirmOrderExperimental week={week} year={year} />
  ) : (
    <WeekEditorConfirmOrderDefault week={week} year={year} />
  );
};
